export function embaralharPropostas(propostas) {
  const embaralhadas = [...propostas];

  for (let indice = embaralhadas.length - 1; indice > 0; indice -= 1) {
    const novoIndice = Math.floor(Math.random() * (indice + 1));
    [embaralhadas[indice], embaralhadas[novoIndice]] = [embaralhadas[novoIndice], embaralhadas[indice]];
  }

  return embaralhadas;
}

export function obterPropostasDoTema(dados, tema, deveEmbaralhar) {
  const topicosDisponiveis = dados.topics.filter((topico) => topico.available);
  const propostas = tema === "todos"
    ? dados.proposals.filter((proposta) => topicosDisponiveis.some((topico) => topico.id === proposta.topic))
    : dados.proposals.filter((proposta) => proposta.topic === tema);

  return deveEmbaralhar ? embaralharPropostas(propostas) : propostas;
}

export function calcularResultado(propostas, respostas) {
  const candidatos = Array.from(new Set(propostas.map((proposta) => proposta.candidate)));
  const totais = Object.fromEntries(candidatos.map((candidato) => [
    candidato,
    propostas.filter((proposta) => proposta.candidate === candidato).length,
  ]));
  const placar = candidatos.map((candidato) => ({ candidato, pontos: 0 }));
  const detalhes = {};

  propostas.forEach((proposta, indice) => {
    if (!detalhes[proposta.candidate]) detalhes[proposta.candidate] = { aprovadas: [], recusadas: [] };
    if (respostas[indice]) {
      placar.find((item) => item.candidato === proposta.candidate).pontos += 1;
      detalhes[proposta.candidate].aprovadas.push(proposta);
    } else {
      detalhes[proposta.candidate].recusadas.push(proposta);
    }
  });

  placar.sort((primeiro, segundo) => (
    segundo.pontos - primeiro.pontos || primeiro.candidato.localeCompare(segundo.candidato, "pt-BR")
  ));

  return { placar, totais, detalhes };
}
